(function () {
    'use strict';

    angular
        .module('app.postScore')
        .component('sc3GolferScorePosting', {
            templateUrl: 'app/post-score/golfer-score-posting.component.html',
            controller: GolferScorePostingComponent,
            bindings: { data: '<' }
        });

    GolferScorePostingComponent.$inject = ['$state', 'surveyModal', 'user'];
    function GolferScorePostingComponent($state, surveyModal, user) {
        var ctrl = this;
        ctrl.redirect = redirect;

        function redirect() {
            surveyModal(user.id).result.then(gotoScoring, gotoScoring);

            function gotoScoring() {
                $state.go('scoring');
            }
        }
    }
})();